import axios from "axios";
import config from "@lib/config";

const api = axios.create({
  baseURL: `${config.apiBaseUrl}/api` || "https://api.floats.ai/api",
});

// Bearer token shared with the request interceptor below. Kept in module scope
// — and the interceptor registered once at import time — so that every request
// is authenticated from the very first render after a full page refresh.
// (Attaching the interceptor from a React effect instead fires too late:
// effects run bottom-up, so child components' mount-time requests would go out
// before a parent provider's effect could add the token, and 401.)
// AxiosProvider keeps this in sync with the current session via setAuthToken().
let authToken = null;

export function setAuthToken(token) {
  authToken = token ?? null;
}

api.interceptors.request.use((requestConfig) => {
  if (authToken) {
    requestConfig.headers.Authorization = `Bearer ${authToken}`;
  }
  return requestConfig;
});

export default api;
